import { AnnouncementDetailDTO, PrintDateDTO } from '@app/src/views/MyAccount/listAvailable/dto/AnnouncementDetailDTO';
import { AnnouncementDetailModel, PrintDateModel } from '@app/src/views/MyAccount/listAvailable/models/AnnouncementDetailModel';

export const hydrateData = (data: AnnouncementDetailDTO): AnnouncementDetailModel => {
  return {
    title: data.title,
    printDates: hydrateDatePrint(data.print_dates),
    extracharges: data.extracharges
  } as AnnouncementDetailModel
};

const hydrateDatePrint = (data: PrintDateDTO[]): PrintDateModel[] => data.map((item: PrintDateDTO) => ({
  publication: item.publication,
  datePrint: item.date_print
} as PrintDateModel));